
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/updates/[slug]",
      function () {
        return require("private-next-pages/updates/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/updates/[slug]"])
      });
    }
  